const styles = theme => ({
  root: {
  },
  imgStyle:{
    width: "100%"
  }
});


export default styles;